import type { LookInsidePage } from './lookInsidePages'

/** Vol. 5 — The Season Show. Real pages, portrait 4:5 (1200×1500). */
export const seasonShowPages: LookInsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/myuWhd93KifGpkY1u5J7R8/01-season-show-cover.jpg',
    mock: 'cover',
    caption: 'A finished group number where every level shines',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/oUMBM8AaPkMVPgxntRQ375/02-season-show-temas.jpg',
    mock: 'cover',
    caption: 'Pick a theme that works on ice',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/aQ8ZkqxRnyUvatAvwWYkHg/03-season-show-grilla-formaciones.jpg',
    mock: 'cover',
    caption: 'Place up to 30 skaters on the formation grid',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hLhzLm6STzRG8QMbhc26dv/04-season-show-final-y-saludos.jpg',
    mock: 'cover',
    caption: 'Build the finale and the bows',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8WXdRLSBYkENiHRyAE92TG/05-season-show-formacion-final.jpg',
    mock: 'cover',
    caption: 'Show finale: phrases 10–12 by level',
  },
]
